import { render, staticRenderFns } from "./ProjectDeliveryDetailsDialog.vue?vue&type=template&id=204a57f2"
import script from "./ProjectDeliveryDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDeliveryDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports